import { useEffect, useState } from 'react';

// Note if this hook is used twice with the same key name the state won't stay in sync with local
// storage. If this becomes a requirement then create a provider.
const useSessionState = <StateType>(keyName: string, defaultValue: StateType) => {
  const [state, setState] = useState<StateType>(() => {
    const storageValue = sessionStorage.getItem(keyName);
    return storageValue ? (JSON.parse(storageValue) as StateType) : defaultValue;
  });

  useEffect(() => {
    sessionStorage.setItem(keyName, JSON.stringify(state));
  }, [keyName, state]);

  return [state, setState] as const;
};

export default useSessionState;
